var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHeartFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:heart-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.205 5.291C19.6536 4.73572 18.9979 4.2949 18.2756 3.99389C17.5532 3.69287 16.7785 3.5376 15.996 3.537C14.5158 3.53724 13.0897 4.09328 12 5.095C10.9104 4.09311 9.48419 3.53705 8.00398 3.537C7.22052 3.53782 6.44495 3.69356 5.72192 3.99527C4.99888 4.29698 4.34265 4.7387 3.79098 5.295C1.43798 7.658 1.43898 11.354 3.79298 13.707L12 21.914L20.207 13.707C22.561 11.354 22.562 7.658 20.205 5.291Z",
    fill: "#E05C5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartFill);
export default __webpack_public_path__ + "static/media/ic_heart-fill.5f5d810b0180dc83ca23e38f0f7f3e52.svg";
export { ForwardRef as ReactComponent };